app = app || {};
app.cw = app.cw || {};
app.cw.telerik = app.cw.telerik || {};

theGridId = "";
let logToConsole = false;

app.cw.telerik.grid = {
    getTypeFriendlyName: function getTypeFriendlyName(type, isAssignedObject) {
        var friendlyname = '';
        switch (type) {
            case 'destroy':
                if (isAssignedObject)
                    friendlyname = 'unassign';
                else
                    friendlyname = 'delete';
                break;
            case 'create':
                if (isAssignedObject)
                    friendlyname = 'assign';
                else
                    friendlyname = 'create';
                break;
            default:
                friendlyname = type;
        }
        return friendlyname;
    },
    onCancelHandler: function onCancelHandler(e) {
        // Fired when the user clicks the "cancel" button (in inline or popup editing mode) or closes the popup window.
        e.sender.dataSource.cancelChanges();
        app.cw.common.Notification.remove();
    },
    onErrorHandler: function onErrorHandler(args, gridId) {

        if (logToConsole) console.log('BEGIN: onErrorHandler');

        // Reference to grid
        var grid = $('#' + gridId).data('kendoGrid');

        // Assign dummy error for undefined errors
        // For example if the server times out "errors" is empty
        if (args.errors) {
            myErrors = args.errors;
        }
        else {
            if (logToConsole) console.log("- Assigned dummy error for undefined error(s)");
            if (args.xhr.responseJSON && args.xhr.responseJSON.message)
                myErrors = { 'Unknown': { 'errors': [args.xhr.responseJSON.message] } };
            else
                myErrors = { 'Unknown': { 'errors': ['Server Error'] } };
        }

        // separate warnings and errors into two arrays
        var allMyErrors = [];
        var allMyWarnings = [];
        var allMyInfo = [];
        $.each(myErrors, function (propertyName) {
            $.each(this, function (name, value) {
                if (propertyName === 'warning') {
                    allMyWarnings = $.merge(allMyWarnings, value);
                }
                else if (propertyName === 'info') {
                    allMyInfo = $.merge(allMyInfo, value);
                }
                else {
                    allMyErrors = $.merge(allMyErrors, value);
                }
            });
        });

        if (logToConsole) console.log("- Information Messages = " + allMyInfo.length);
        if (logToConsole) console.log("- Warning Messages = " + allMyWarnings.length);
        if (logToConsole) console.log("- Error Messages = " + allMyErrors.length);

        if (allMyInfo.length > 0) {
            app.cw.common.Notification.show('Information', allMyInfo, 'infoList');
        }

        if (allMyWarnings.length > 0) {
            app.cw.common.Notification.show('Warning', allMyWarnings, 'warningList');
        }

        if (allMyErrors.length > 0) {
            app.cw.common.Notification.show('Errors', allMyErrors, 'errorList');
        }

        if (logToConsole) console.log("- Displayed list of validation errors to user");

        // cancel grid rebind so that popup stays in place
        grid.one('dataBinding', function (e) {
            e.preventDefault();
        });

        if (logToConsole) console.log("END: onErrorHandler");

    },
    
    onRequestEndHandler: function onRequestEndHandler(e, gridId, objectType, isAssignedObject) {
        var grid = $('#' + gridId).data('kendoGrid');

        // Check request type
        if (e.type === 'create' || e.type === 'update' || e.type === 'destroy') {

            // Remove any existing messages that might be on the screen
            app.cw.common.Notification.remove();

            // check for errors in the response
            // TODO: status evaluation must be improved
            // for successful create: boolean
            // for successful read: object
            // for non-json result: string (404 or other)

            // count how many actual errors and warnings we have
            var numberOfErrors = 0;
            var numberOfWarnings = 0;
            var numberOfInfo = 0;
            $.each(e.response.Errors, function (propertyName) {
                if (propertyName === 'warning')
                    numberOfWarnings += 1;
                else if (propertyName === 'info')
                    numberOfInfo += 1;
                else
                    numberOfErrors += 1;
            });

            if (logToConsole) console.log("- Information Messages = " + numberOfInfo);
            if (logToConsole) console.log("- Warning Messages = " + numberOfWarnings);
            if (logToConsole) console.log("- Error Messages = " + numberOfErrors);

            if (typeof (e.response) !== 'string' && (e.response === null || e.response.Errors === null || numberOfErrors === 0)) {

                // OPERATION SUCCEEDED
                var opMessage = app.cw.common.FormatString.titleCase(app.cw.telerik.grid.getTypeFriendlyName(e.type, isAssignedObject) + ' ' + objectType + ' succeeded');

                // display a "success" message
                app.cw.common.Notification.displaySuccess(opMessage);

                if (logToConsole) console.log("- Message: " + opMessage);

                // Refresh grid after success

                if (logToConsole) console.log("- Refreshed grid after " + e.type.toUpperCase());
                grid.dataSource.read();
            }
            else {

                // OPERATION FAILED

                opMessage = app.cw.common.FormatString.titleCase(app.cw.telerik.grid.getTypeFriendlyName(e.type, isAssignedObject) + " " + objectType + " failed");

                // display an "error" message
                app.cw.common.Notification.displayError(opMessage, 'Operation Failed');

                if (logToConsole) console.log("- Message: " + opMessage);

                if (e.type === 'destroy') {
                    // Cancel any pending changes in the data source.
                    // http://docs.telerik.com/kendo-ui/api/javascript/ui/grid#methods-cancelChanges
                    grid.cancelChanges();
                    if (logToConsole) console.log("- Cancelled pending changes to data source");
                }

            }

        }

        if (logToConsole) console.log("END: onRequestEndHandler");

    }
};